/**
 *  Filename ....: match.component.ts
 *  Created by ..: ianday
 *  on Date .....: 11/14/23
 **/
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ServiceRequest } from "../../../../models/service.request";
import { AgenciesService } from "../../../../services/agencies.service";
import { Settings } from "../../../../services/settings";
import { Agencies } from "../../../../models/agencies";
import { MatTableDataSource } from "@angular/material/table";
import { ServiceRequestsService } from "../../../../services/service-requests.service";
import { TransactionHistoryService } from "../../../../services/transactionhistory.service";
import { MessageDefinition } from "../../../../models/message-definition";
import { MessageDefinitionService } from "../../../../services/messages.service";
import { NewMessageHelper } from "../../drawer/mailmessages/newmessage/newmessage-helper";
import { Case } from "../../../../models/case";
import { MailOption } from "../../../../models/mail-option";
import { MessagesSent } from "../../../../models/messages-sent";
import { CasesService } from "../../../../services/cases.service";
import { ServiceDefService } from "../../../../services/servicedef.service";
import { GlobalService } from 'src/app/services/global.service';
import { MatDialog } from '@angular/material/dialog';
import { MessageBoxComponent } from 'src/app/components/message-box/message-box.component';

class DataRecord {
	id: number;
	description: string;
	constructor(id: number, desc: string) {
		this.id = id;
		this.description = desc;
	}
}
@Component({
	selector: 'app-match',
	templateUrl: './match.component.html',
	styleUrls: ['./match.component.css']
})

export class MatchComponent implements OnInit {

	public _requestStatusList: any;
	public _serviceRequest: ServiceRequest;
	public strErr: string | null = '';
	public unAssignFlag: boolean = false;
	assignToAnyAgency = false;
	assignToMyAgency = false;
	visibleUnAssignBtn = false;
	assignOption: string = 'any';

	public currentAgency: string;
	public selectedAgency: Agencies;
	public selectedRecord: any;
	public agencyServicesList: any;
	public enableSubmit: boolean | null = false;
	public enableCancel: boolean | null = true;
	public dataSource: MatTableDataSource<any>;
	public Idx: number = -1;
	public matched: boolean = false;
	public histRequest: any;
	public msgDefinition: MessageDefinition;
	public msgHelper: NewMessageHelper;
	public caseInfo: Case;
	public displayEmailConfirmation: boolean = false;

	public displayedColumns = ['id', 'agencyName', 'serviceDescription'];

	@Output() cancelClicked = new EventEmitter();
	@Output() submitClicked = new EventEmitter<any>();

	@Input() set serviceRequest(val: any) {
		this._serviceRequest = val;
		this.histRequest = Object.assign({}, val);

	}
	public get serviceRequest(): ServiceRequest {
		return this._serviceRequest;
	}

	constructor(public agencyService: AgenciesService,
		public messageService: MessageDefinitionService,
		public serviceDefsService: ServiceDefService,
		public serviceRequestService: ServiceRequestsService,
		public txService: TransactionHistoryService,
		public globalService: GlobalService,
		public dialog: MatDialog) {
	}

	ngOnInit() {
		this.assignToAnyAgency = Settings.getInstance().hasPrivilege('REQUEST_DETAIL_MATCH_ASSIGN_ANY_AGENCY', "EXECUTE");
		this.assignToMyAgency = Settings.getInstance().hasPrivilege('REQUEST_DETAIL_MATCH_ASSIGN_MY_AGENCY', "EXECUTE");
		this.visibleUnAssignBtn = Settings.getInstance().hasPrivilege('REQUEST_DETAIL_MATCH_UNASSIGN', "EXECUTE");
	}

	public doInitialize(ag: Agencies): void {

		if (ag !== undefined) {
			this.currentAgency = ag.agencyName;
		}
		else {
			this.currentAgency = '<No agency>';
		}
		this.histRequest = Object.assign({}, this.serviceRequest);
		switch (this.serviceRequest.requestStatusId) {
			case 1:         //unmatched
				this.matched = false;
				break;
			case 2:         //matched
				this.matched = true;
				break;
			default:        // done - can't do anything.
				break;
		}

		if (!this.assignToAnyAgency) {
			if (this.assignToMyAgency) {
				this.assignOption = 'my';
			}
		} else {
			this.assignOption = 'any';
		}

		this.loadQualifyingAgencies();
	}

	public loadQualifyingAgencies(): void {

		/*** initializations ***/
		this.unAssignFlag = false;
		this.agencyServicesList = new Array();
		this.strErr = '';

		if (this.serviceRequest.zipCode.length === 0) {
			this.strErr = 'Error: no zip-code present - please add one in the case tab before attempting a match';
			return;
		}

		this.agencyService.getQualifyingAgencies(this.serviceRequest.serviceRequestTypeId, this.serviceRequest.zipCode).subscribe(
			(results) => {

				const localIdx = results.findIndex(i => i.serviceDefId === this.serviceRequest.serviceDefId);

				/**  peel off the existing service record - so it doesn't appear for selection again. **/
				if (this.matched === true) {
					if ((localIdx !== null) && (localIdx > -1)) {
						results.splice(localIdx, 1);
					}
				}
				if (this.assignToAnyAgency) {
					this.agencyServicesList = results;
				} else if (this.assignToMyAgency) {
					this.agencyServicesList = results.filter(item => item.id === Settings.getInstance().loggedInUser.agencyId);
				} else {
					this.agencyServicesList = [];
				}
				this.dataSource = new MatTableDataSource(this.agencyServicesList);
			},
			(error) => {
				Settings.getInstance().handleError(error, 'getting agencies');
			});
	}
	public tableKeyDown(event: KeyboardEvent) {

		const len: number = this.dataSource.filteredData.length;
		if (event.key === 'ArrowDown') {
			if (this.Idx < (len - 1)) {
				this.selectedRecord = this.dataSource.filteredData[++this.Idx];

			}
		} else if (event.key === 'ArrowUp') {
			if (this.Idx > 0) {
				this.selectedRecord = this.dataSource.filteredData[--this.Idx];

			}
		}
		else if (event.key === 'Enter') {
			this.selectedRecord = this.dataSource.filteredData[this.Idx];
			this.onSubmitClicked();             // just select it!
		}
	}
	public onRowClicked(row: any): void {
		this.selectedRecord = row;
		this.Idx = this.dataSource.connect().value.indexOf(this.selectedRecord);
		this.enableSubmit = true;
	}

	public doUnAssignCheckBoxChange(event: any): void {

		if (event.checked === true) {
			this.enableSubmit = true;
			this.Idx = -1;
		}

	}
	public onSubmitClicked(): void {
		if(this.serviceRequest.clericalOpen ===1) {
			this.displayEmailConfirmation = true;
		} else {
			this.updateRecord(true);
		}
	}
	public onEmailConfirm(event: any): void {
		this.displayEmailConfirmation = false;
		if(event == "YES") 
			this.updateRecord(true);
		else
			this.updateRecord(false);		
	}
	public updateRecord(emailFlag=true): void {
		let txString: string = '';

		if (this.unAssignFlag === true) {
			this.serviceRequest.agencyId = 0;
			this.serviceRequest.serviceDefId = 0;
			this.serviceRequest.requestStatusId = 1;
			this.serviceRequest.keepOpen = 0;
			/** was the request previously matched
			 * with an agency and has become unmatched? **/
			if (this.histRequest.requestStatusId === 2) {
				this.serviceRequest.assignAttempts++;
			}
			this.serviceRequest.requestStatusDesc = 'Unmatched';
			txString = 'Unassigned from: ' + this.currentAgency;
		}
		else {
			this.serviceRequest.agencyId = this.selectedRecord.id;
			this.serviceRequest.serviceDefId = this.selectedRecord.serviceDefId;
			this.serviceRequest.requestStatusId = 2;

			/** did we match this request with another agency? **/
			/** note if it is just a service def change within the agency we won't send an email **/

			if (this.histRequest.agencyId != this.serviceRequest.agencyId) {
				this.serviceRequest.assignAttempts++;
				this.serviceRequest.keepOpen = 0;
			}
			this.serviceRequest.requestStatusDesc = 'Matched';
			txString = 'Reassigned to: ' + this.selectedRecord.agencyName;
		}

		/** update the service Request record **/
		this.globalService.openDialog();
		this.serviceRequestService.updateRequestsMatch(this.serviceRequest, emailFlag).subscribe(
			(result) => {

				/** post a transaction history record **/
				this.txService.createTransactionHistory('ServiceRequests', this.serviceRequest.id, 'Change Match', 'Change Match Assignment', txString);

				this.histRequest = Object.assign({}, this.serviceRequest);
				this.submitClicked.emit(this.serviceRequest);
				this.globalService.closeDialog();
			},
			(error) => {
				Settings.getInstance().handleError(error, 'updating match details for a service request');
				this.histRequest = Object.assign({}, this.serviceRequest);
				this.submitClicked.emit(this.serviceRequest);
				this.globalService.closeDialog();
			});
	}

	public onCancelClicked(): void {
		this.cancelClicked.emit();
	}

	public sendMessageByEvent(evCode: string): void {

		this.enableSubmit = this.enableCancel = false;
		this.msgHelper = new NewMessageHelper(this.messageService, this.serviceDefsService, this.serviceRequestService, this.serviceRequest.agencyId);
		this.msgHelper.messageSentSuccessEv.subscribe(() => {
			this.enableSubmit = this.enableCancel = true;
			this.submitClicked.emit(this.serviceRequest);
			this.globalService.closeDialog();
		});
		this.msgHelper.messageSentFailureEv.subscribe((error) => {
			this.enableSubmit = this.enableCancel = true;
			this.submitClicked.emit(this.serviceRequest);
			this.globalService.closeDialog();
			if (error != "NO_MESSAGE_DEF")
				Settings.getInstance().handleError('Unable to send email');
		});
		this.msgHelper.evCode = evCode;
		/** this method daisy chains through to send the message. **/
		this.msgHelper.setRecords(this.caseInfo, this.serviceRequest, true);

		// this.msgHelper.autoSendMessageByEvent(evCode);

	}
}


